export default __webpack_public_path__ + "static/winter19-54520a400510fd675e143df02d6607ff.webp";